import CustomPrintPanZoomPhoto from './CustomPrintPanZoomPhoto';

export default CustomPrintPanZoomPhoto;
